module.exports = __webpack_public_path__ + "fonts/line-awesome.3f85d80.eot";